import {inject, Injectable} from '@angular/core';
import {StorageService} from './storage.service';

const REDIRECT_URL_KEY = 'pendingRedirectUrl';

@Injectable({
  providedIn: 'root'
})
export class RedirectService {
  private storageService = inject(StorageService);

  async setRedirectUrl(url: string): Promise<void> {
    if (url && url !== '/' && url !== '/login') {
      await this.storageService.set(REDIRECT_URL_KEY, url);
    }
  }

  async getRedirectUrl(): Promise<string | null> {
    return await this.storageService.get(REDIRECT_URL_KEY);
  }

  async clearRedirectUrl(): Promise<void> {
    await this.storageService.remove(REDIRECT_URL_KEY);
  }

  async getAndClearRedirectUrl(): Promise<string | null> {
    const url = await this.getRedirectUrl();
    if (url) {
      await this.clearRedirectUrl();
    }
    return url;
  }
}
